import { createStore, applyMiddleware, compose, StoreEnhancerStoreCreator } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'connected-react-router';

import rootReducer from './rootReducer';
import rootSaga from './rootSaga';
import history from './history';

const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware, routerMiddleware(history)];

let devToolsExtension: undefined | StoreEnhancerStoreCreator;

/* istanbul ignore if  */
if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { createLogger } = require('redux-logger');

  const logger = createLogger({ collapsed: true });
  middlewares.push(logger);

  if (window.__REDUX_DEVTOOLS_EXTENSION__) {
    devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__();
  }
}

export type TRootState = ReturnType<typeof configureStore>;

export default function configureStore<S extends {}>(initialState: S) {
  const mids = applyMiddleware(...middlewares);
  const store = createStore(
    rootReducer,
    initialState,
    devToolsExtension ? compose(mids, devToolsExtension) : mids
  );

  sagaMiddleware.run(rootSaga);

  /* istanbul ignore if  */
  if (module.hot) {
    module.hot.accept('./rootReducer', () => {
      const nextRootReducer = require('./rootReducer').default;
      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
}
